import React from 'react'

export default [
  {
    title: '时间',
    dataIndex: 'created_at',
    key: 'created_at'
  },
  {
    title: '购买活动点数',
    dataIndex: 'value',
    key: 'value'
  },
  {
    title: '付款信息',
    dataIndex: 'price',
    key: 'price',
    render: price => <span>{price}元</span>
  }
]
